import type { AxiosInstance } from 'axios'
import type {
  IAuthService,
  IAuthAuth0ResponseData
} from './auth.types'
import type { IUserData } from '@/models/user'
import axios from '@/api/axios'

/**
 * A class representing a AuthService API handler.
 */
export class AuthService implements IAuthService {
  private endpoint: string

  // UserService constructor
  constructor(private axios: AxiosInstance) {
    this.endpoint = 'auth/'
  }

  authorizeAuth0(code: string): Promise<IAuthAuth0ResponseData> {
    return this.axios
      .post(`${this.endpoint}auth0/`, { code })
      .then(({ data }) => data)
  }

  authorizeMicrosoft(code: string, redirect_uri: string): Promise<IAuthAuth0ResponseData> {
    return this.axios
      .post(`${this.endpoint}microsoft/`, { code, redirect_uri })
      .then(({ data }) => data)
  }


  // Method to logout currently authenticated user
  logout(): Promise<void> {
    return this.axios.post(`${this.endpoint}logout/`)
  }

  async changePassword(new_password1: string, new_password2: string) {
    return this.axios
      .post(`${this.endpoint}password/change/`, {
        new_password1,
        new_password2
      })
      .then(({ data }) => data)
  }

  // Method to fetch currently authenticated user from the API
  fetchAuthUser(): Promise<IUserData> {
    return this.axios.get(`${this.endpoint}user/`).then(({ data }) => data)
  }

  // Method to update currently authenticated user from the API
  updateAuthUser(data: IUserData): Promise<IUserData> {
    return this.axios.patch(`${this.endpoint}user/`, data).then(({ data }) => data)
  }
}

// Default export instantiation of the AuthService
const authService = new AuthService(axios)
export default authService
